var map = {
	"./alert-triangle.svg": 5569,
	"./calendar-blue.svg": 5797,
	"./calendar-check.svg": 719,
	"./calendar.svg": 9996,
	"./check.svg": 3814,
	"./checkmark-icon.svg": 1829,
	"./chevron-black-down.svg": 1718,
	"./chevron-down.svg": 4116,
	"./chevron-thick-black.svg": 7577,
	"./chevron-thin.svg": 5542,
	"./chevron-white-down.svg": 3460,
	"./chevron-white-right.svg": 70,
	"./exclamation.svg": 3537,
	"./exit.svg": 1710,
	"./file-plus.svg": 2277,
	"./flagship.svg": 9770,
	"./get-help.svg": 2,
	"./icon-book.svg": 5953,
	"./icon-calender.svg": 5900,
	"./icon-vaccine.svg": 9983,
	"./icons.svg": 9260,
	"./logo-footer.svg": 5745,
	"./map-pin.svg": 4574,
	"./pharmacy.svg": 1029,
	"./phone.svg": 1814,
	"./red-alert-triangle.svg": 415,
	"./red-check.svg": 2404,
	"./search.svg": 4926,
	"./travel.svg": 9034,
	"./user.svg": 4695,
	"./x-circle.svg": 9615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9027;